import React from 'react';
import PlansContainer from './PlansContainer';

const PlansView = () => {
  return <PlansContainer></PlansContainer>;
};

export default PlansView;
